<template>
    <div class="exercises_list">
        <el-input size="mini" v-model="query.keyword" placeholder="请输入习题名称或ID"></el-input>
        <el-select size="mini" v-model="query.status" placeholder="请选择">
            <el-option label="全部" value="">全部</el-option>
            <el-option label="已上架" value="1">已上架</el-option>
            <el-option label="已下架" value="2">已下架</el-option>
        </el-select>
        <el-input size="mini" v-model="query.course_title" placeholder="关联课程"></el-input>
        <el-input size="mini" v-model="query.course_item_title" placeholder="关联课时"></el-input>
        <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        <el-button size="mini" type="primary" @click="opencompile({},1)">添加习题</el-button>
        <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0" >
                <el-table-column label="id" align="center" min-width="2%">
                    <template slot-scope="{ row }">
                        <div>{{row.id}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="习题名称" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <div style="color:#409eff;cursor: pointer;" @click="opencompile(row,2)">{{row.title}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="关联课程" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <div>{{row.courses_title}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="关联课时" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <div>{{row.courses_item_title}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center" min-width="3%">
                    <template slot-scope="{ row }">
                        <div>{{row.created_at}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="题目总数" align="center" min-width="2%">
                    <template slot-scope="{ row }">
                        <div>{{row.total_quantity}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="答题人数" align="center" min-width="2%">
                    <template slot-scope="{ row }">
                        <div style="color:#409eff;cursor: pointer;" @click="$router.push(`/exercises/answerpeople?id=${row.id}&title=${row.title}`)">{{row.use_number}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="7%">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="opencompile(row,2)">编辑</el-button>
                        <el-button type="text" :style="{color:row.status ==1?'red':'#409eff'}" @click="setUpDown(row)">{{ row.status ==1?'下架':'上架' }}</el-button>
                        <el-button type="text" @click="$router.push(`/exercises/topic?id=${row.id}`)">题目配置</el-button>
                        <el-button type="text" @click="copyHandel(row)">复制习题</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
                    layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog :title="istype ==2?'编辑习题':'添加习题'" :visible.sync="compilecoursedialogVisible" width="20%" >
            <el-form :model="complieform" label-width="100px" class="demo-adept">
                <el-form-item label="习题名称" class="is-required comdialog">
                    <el-input v-model="complieform.title" class="redactinput" maxlength="50"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" style="display:flex;justify-content:center">
                <el-button @click="compilecoursedialogVisible = false" style="margin-right: 30px;">取 消</el-button>
                <el-button type="primary" @click="compilecourseHandel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getcourseList,createUpdateName,setUpDown,questionCopy
} from "@/api/exercises";
export default {
    name: "",
    data() {
        return {
            query: {
                keyword: "",
                status: "",
                course_title: "",
                course_item_title: "",
                page: 1,
                limit: 30,
            },
            loading: true,
            total: 0,
            list: [],
            compilecoursedialogVisible:false,  
            complieform: {
                title: "",
                id:'',
            },
            istype:0
        };
    },
    components: {},
    computed: {},
    // mounted() {
    //     this.getList() 
    // },
    created(){
        this.getList() 
    },
    methods: {
        copyHandel(row){
            questionCopy({id:row.id}).then((res)=>{
                if(res.code == 1){
                    this.$message({
                    message:'复制成功' ,
                    type: "success",
                });
                this.getList()
                }
            })
        },
        setUpDown(value){
            let option ={
                id:value.id,
                status:value.status==1?0:1
            }
            setUpDown(option).then((res)=>{
                if(res.code == 1){
                    this.$message({
                    message:value.status==1?'下架成功':'上架成功' ,
                    type: "success",
                });
                    this.getList()
                }
            })
        },
        opencompile(row,index){ // 打开编辑弹窗
            if(index == 2){
            this.complieform.title = row.title
            this.complieform.id = row.id
            this.istype = 2
            this.compilecoursedialogVisible = true
            }else{
                this.complieform.title = ""
                this.complieform.id = ""
                this.istype =1
                this.compilecoursedialogVisible = true
            }
        },
        compilecourseHandel(){ // 编辑习题
            if (this.complieform.title == "") {
                this.$message({
                    message: "请输入习题名称!",
                    type: "error",
                });
                return false;
            }
            this.createUpdateName()
        },
        createUpdateName(){ // 创建、编辑习题名称
            createUpdateName(this.complieform).then((res)=>{
              if (res.code == 1) {
                this.$message({
                  message: "操作成功!",
                  type: "success",
                });
                this.getList()
                this.compilecoursedialogVisible = false
                this.complieform.title = ''
                this.complieform.id = ''
              }
            })
        },
        getList() {  // 获取列表数据
            getcourseList(this.query).then((res)=>{
                if(res.code ==1){
                    this.list = res.data.list
                    this.total = res.data.total
                    this.loading = false
                }
            })
        },
    },
};
</script>

<style>
.exercises_list {
    position: relative;
}
.exercises_list .el-input {
    width: 200px;
    margin-right: 30px;
}
.exercises_list .block .el-input{
    width: 60px;
}
.exercises_list .comdialog .el-input{
    width: 100%;
}
</style>
